// Maps a colour/shade name to a CSS background for little swatch chips.
const MAP = [
  [/custom/i, 'conic-gradient(from 90deg, #c6a15b, #e6cd94, #7d3f1f, #3d0f1c, #171717, #c6a15b)'],
  // Fashion pixie (curly) shades
  [/t1b\/350/i, 'linear-gradient(180deg, #191919 0%, #191919 30%, #c25a1e 100%)'],
  [/t1b\/30\b/i, 'linear-gradient(180deg, #191919 0%, #191919 32%, #7a3b1a 100%)'],
  [/t1b\/27/i, 'linear-gradient(180deg, #191919 0%, #191919 32%, #c99a5b 100%)'],
  [/p4\/27/i, 'linear-gradient(135deg, #4a2c1a 0%, #4a2c1a 45%, #d9a441 100%)'],
  [/p4\/350/i, 'linear-gradient(135deg, #4a2c1a 0%, #4a2c1a 45%, #c25a1e 100%)'],
  [/4\/30\b/i, 'linear-gradient(135deg, #4a2c1a 0%, #7a3b1a 100%)'],
  // Fashion pixie ombrés (dark root -> tip) — must match before solid shades
  [/t1b\/613/i, 'linear-gradient(180deg, #191919 0%, #191919 32%, #e6cd94 100%)'],
  [/t1b\/red/i, 'linear-gradient(180deg, #191919 0%, #191919 30%, #b0201f 100%)'],
  [/t2\/130/i, 'linear-gradient(180deg, #2e1a10 0%, #2e1a10 30%, #b5451f 100%)'],
  [/t1b\/99j/i, 'linear-gradient(180deg, #191919 0%, #191919 32%, #3d0f1c 100%)'],
  [/t1b\/bug/i, 'linear-gradient(180deg, #191919 0%, #191919 32%, #5b0f2a 100%)'],
  [/t1b\/33/i, 'linear-gradient(180deg, #191919 0%, #191919 32%, #5a2417 100%)'],
  [/t1b\/6\b/i, 'linear-gradient(180deg, #191919 0%, #191919 30%, #6b4a2a 100%)'],
  [/t1b\/4\b/i, 'linear-gradient(180deg, #191919 0%, #191919 30%, #4a2c1a 100%)'],
  [/t1b\/2\b/i, 'linear-gradient(180deg, #191919 0%, #191919 30%, #2e1a10 100%)'],
  [/\bbug\b|burgundy/i, '#5b0f2a'],
  [/\b350\b|ginger|copper/i, '#c25a1e'],
  [/\b14\b|ash blonde/i, '#9c8a54'],
  [/jet black/i, '#050505'],
  [/off black|natural 1b|^1b/i, '#191919'],
  [/dark burgundy|99j/i, '#3d0f1c'],
  [/dark auburn|33/i, '#5a2417'],
  [/medium auburn|30/i, '#7d3f1f'],
  [/light auburn|27/i, '#b5723d'],
  [/medium dark brown|4 /i, '#4a2c1a'],
  [/dark brown|2 /i, '#2e1a10'],
  [/bright blonde|613|blonde/i, '#e6cd94'],
  [/ginger|copper|orange/i, '#c96a2a'],
  [/burgundy|wine/i, '#4a1524'],
  [/red/i, '#8f1d1d'],
  [/blue/i, '#2f5bd0'],
  [/purple|violet|plum/i, '#6d3aa8'],
  [/pink|rose/i, '#d85a86'],
  [/green|emerald/i, '#2f8f6b'],
  [/transparent/i, 'linear-gradient(135deg, #efe6d6, #d9ccb6)'],
  [/champagne/i, '#efe0bf'],
  [/blush/i, '#e6b8b2'],
  [/mint/i, '#bfe6d2'],
  [/gold/i, '#c6a15b'],
  [/black/i, '#111111'],
];

export const swatchFor = (name = '') => {
  for (const [re, bg] of MAP) if (re.test(name)) return bg;
  return '#c9b892';
};
